import React from "react";
import ChecklistIcon from "icons/ChecklistIcon";
import store from "glassRedux/store";
import {
  addChecklist,
  removeChecklist,
} from "shared/itemLists/redux/itemListsSlice";

export default function ChecklistButton(props) {
  const {
    itemHasChecklist,
    setItemHasChecklist,
    setOpenChecklist,
    itemId,
  } = props;

  function handleChecklistButtonClick() {
    if (!itemHasChecklist) {
      store.dispatch(addChecklist());
      setItemHasChecklist(true);
      setOpenChecklist((currOC) => {
        return { ...currOC, isOpen: true, itemId: itemId };
      });
    } else {
      setItemHasChecklist(false);
      store.dispatch(removeChecklist());
    }
  }

  const className = itemHasChecklist
    ? "item-details-big-button remove-checklist"
    : "item-details-big-button add-checklist";
  const buttonText = itemHasChecklist ? "Remove Checklist" : "Add Checklist";
  return (
    <button className={className} onClick={handleChecklistButtonClick}>
      <span className="checklist-icon">
        <ChecklistIcon />
      </span>
      {buttonText}
    </button>
  );
}
